import React, { useState } from "react";
import CollectionBanner from "../../Components/CollectionBanner.jsx";
import { FilterModal } from "../../Components/FilterModal.jsx";
import FilterSection from "../../Components/FilterSection.jsx";
import HorizontalListCard from "../../Components/HorizontalListCard.jsx";
import { Navbar2 } from "../../Components/Navbar2/Navbar2.js";
import { sortingData } from "../../Constant/Data.js";
import useProductByCategory from "./useProductByCategory.js";
import Pagination from "../../Components/Pagination.jsx";
import SelectBoxSimple from "../../Components/SelectBoxSimple.jsx";
import { FunnelIcon } from "@heroicons/react/20/solid";
import EmptyList from "../../Components/EmptyList.jsx";
import { emptyItem } from "../../assets/Images.js";
import HorizontalCardLoader from "../../Components/HorizontalCardLoader.jsx";
import PlaylistCard from "../../Components/Playlist/PlaylistCard.jsx";
import PlaylistCardLoader from "../../Components/Playlist/PlaylistCardLoader.jsx";
import {
  MagnifyingGlassIcon,
  Squares2X2Icon,
  ListBulletIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import FooterNew from "../../Components/LandingNew/FooterNew.jsx";

const accessTabs = [
  { id: "all", label: "All Content", shortLabel: "All", icon: "✨" },
  { id: "free", label: "Free Content", shortLabel: "Free", icon: "🎁" },
  { id: "buy", label: "One-Time Buy", shortLabel: "Buy", icon: "🏷️" },
  { id: "ppv", label: "Pay-Per-View", shortLabel: "PPV", icon: "🎟️" },
  { id: "exclusive", label: "Exclusive VIP", shortLabel: "VIP", icon: "👑" },
];

export default function ProductByCategory() {
  const {
    items,
    selectedCategory,
    sortBy,
    totalItemsCount,
    currentPage,
    lastPage,
    perPageCount,
    listData,
    selectedFilter,
    selectedAccessType,
    accessTypeCounts,
    onSelectAccessType,
    onResetAccessFilter,
    onSelect,
    onSorting,
    getItems,
    loading,
    viewMode,
    setViewMode,
    onViewModeChange,
    tracksCount,
    playlistsCount,
    playlists,
    playlistsLoading,
    filteredPlaylists,
    playlistSearchQuery,
    setPlaylistSearchQuery,
    cardLayout,
    setCardLayout,
    categorySearchQuery,
    setCategorySearchQuery,
    activeFilterCount,
    onClearAllFilters,
  } = useProductByCategory();

  let data = window?.history?.state?.usr || {};
  let { type } = data || {};
  const [category, setCategory] = useState(type || "ebook");
  const [open, setOpen] = React.useState(false);
  const openFilter = () => setOpen(true);
  const closeFilter = () => setOpen(false);

  const isMusic =
    category === "music" ||
    selectedCategory?.name?.toLowerCase()?.includes("music") ||
    selectedCategory?.name?.toLowerCase()?.includes("song");
  const isMovie = category === "movie";
  const isEbook = category === "ebook";
  const isAudioBook = category === "audio_book";

  const categoryTitle = isAudioBook
    ? "Audio Books"
    : isEbook
      ? "E-Books"
      : isMusic
        ? "Musics"
        : isMovie
          ? "Movies"
          : "Seasons";

  const bannerImage = isAudioBook
    ? "https://s.zst.com.br/cms-assets/2021/05/audio_books_zoom_capa.jpg"
    : isEbook
      ? "https://perspectivesonreading.com/wp-content/uploads/2019/03/POR-Reading-Heros1.jpg"
      : isMusic
        ? "https://fiverr-res.cloudinary.com/images/q_auto,f_auto/gigs3/313825339/original/e43988be7a19cbf652a84d7cb57bc0f17ef53f3a/design-amazing-music-album-cover.png"
        : isMovie
          ? "https://149512919.v2.pressablecdn.com/wp-content/uploads/2021/12/philly-movies-hero-banner.jpg"
          : "Seasons";

  const onCategoryPress = (type) => {
    setCategory(type);
    window.scrollTo(0, 0);
  };

  const activeTabConfig = accessTabs.find(
    (tab) => tab.id === selectedAccessType
  );

  return (
    <>
      <Navbar2
        {...{
          category,
          onCategoryPress,
        }}
      />
      <div className="min-h-screen bab-new-bg text-white transition-colors duration-300">
        {/* Compact, Cinematic Modern Hero Banner */}
        <CollectionBanner
          bannerImage={selectedCategory?.image || bannerImage}
          categoryTitle={
            selectedAccessType === "exclusive" && !selectedCategory
              ? "Exclusive VIP Releases"
              : selectedCategory?.name || categoryTitle
          }
        />

        {/* ========================================================================= */}
        {/* UNIFIED STICKY GLASSMORPHIC FLOATING HUD (WORLD-CLASS MOBILE & DESKTOP TOOLBAR) */}
        {/* ========================================================================= */}
        <div className="sticky top-[70px] md:top-[85px] z-30 backdrop-blur-xl bg-zinc-950/95 border-b border-zinc-800/80 shadow-2xl shadow-black/70 px-3 sm:px-6 lg:px-14 py-2.5">
          <div className="max-w-7xl mx-auto flex flex-col gap-2.5">
            {/* TIER 1 (MUSIC ONLY): Prominent Spotify/Apple Music Style Segmented Mode Selector */}
            {isMusic && (
              <div className="w-full">
                <div className="grid grid-cols-2 p-1 bg-zinc-900/90 border border-zinc-800/80 rounded-2xl backdrop-blur-lg shadow-inner gap-1">
                  <button
                    onClick={() => onViewModeChange("tracks")}
                    className={`flex items-center justify-center gap-1.5 sm:gap-2 py-2 px-2.5 sm:px-4 rounded-xl text-xs sm:text-sm font-black transition-all duration-300 ${viewMode === "tracks"
                      ? "bg-secondary text-white shadow-lg shadow-secondary/30 scale-[1.01]"
                      : "text-zinc-400 hover:text-white hover:bg-zinc-800/40"
                      }`}
                  >
                    <span className="text-sm">🎵</span>
                    <span className="truncate">Songs & Singles</span>
                    <span
                      className={`text-[10px] px-1.5 py-0.5 rounded-full font-bold transition-colors ${viewMode === "tracks"
                        ? "bg-black/30 text-white"
                        : "bg-zinc-800 text-zinc-400"
                        }`}
                    >
                      {items?.length || 0}
                    </span>
                  </button>

                  <button
                    onClick={() => onViewModeChange("playlists")}
                    className={`flex items-center justify-center gap-1.5 sm:gap-2 py-2 px-2.5 sm:px-4 rounded-xl text-xs sm:text-sm font-black transition-all duration-300 ${viewMode === "playlists"
                      ? "bg-secondary text-white shadow-lg shadow-secondary/30 scale-[1.01]"
                      : "text-zinc-400 hover:text-white hover:bg-zinc-800/40"
                      }`}
                  >
                    <span className="text-sm">💿</span>
                    <span className="truncate">Curated Playlists</span>
                    <span
                      className={`text-[10px] px-1.5 py-0.5 rounded-full font-bold transition-colors ${viewMode === "playlists"
                        ? "bg-black/30 text-white"
                        : "bg-zinc-800 text-zinc-400"
                        }`}
                    >
                      {playlists?.length || 0}
                    </span>
                  </button>
                </div>
              </div>
            )}

            {/* TIER 2: Roomy Live Search Input + Essential Quick Actions */}
            <div className="flex items-center justify-between gap-2 sm:gap-4">
              {/* Live Search Input - Dynamically adapts to active view */}
              <div className="relative flex-1">
                <MagnifyingGlassIcon className="w-4 h-4 text-zinc-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
                <input
                  type="text"
                  value={viewMode === "playlists" ? playlistSearchQuery : categorySearchQuery}
                  onChange={(e) => {
                    if (viewMode === "playlists") {
                      setPlaylistSearchQuery(e.target.value);
                    } else {
                      setCategorySearchQuery(e.target.value);
                    }
                  }}
                  placeholder={
                    viewMode === "playlists"
                      ? "Search playlists by title or mood..."
                      : `Search in ${selectedCategory?.name ||
                      (selectedAccessType === "exclusive" ? "Exclusive Content" : categoryTitle)
                      }...`
                  }
                  className="w-full bg-zinc-900/90 border border-zinc-800/90 focus:border-secondary pl-9 pr-8 py-2 rounded-xl text-xs sm:text-sm text-white placeholder-zinc-500 focus:outline-none transition-colors shadow-inner"
                />
                {(viewMode === "playlists" ? playlistSearchQuery : categorySearchQuery) && (
                  <button
                    onClick={() => {
                      if (viewMode === "playlists") {
                        setPlaylistSearchQuery("");
                      } else {
                        setCategorySearchQuery("");
                      }
                    }}
                    className="absolute right-2.5 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-white p-0.5 rounded-full hover:bg-zinc-800 transition-colors"
                  >
                    <XMarkIcon className="w-3.5 h-3.5" />
                  </button>
                )}
              </div>

              {/* Action Toolbar */}
              <div className="flex items-center gap-1.5 sm:gap-2.5 flex-shrink-0">
                {/* Mobile Filter Button (Tracks View only) */}
                {viewMode === "tracks" && (
                  <button
                    onClick={openFilter}
                    aria-label="Open Filters"
                    className={`lg:hidden flex items-center gap-1.5 px-3 py-2 rounded-xl border font-bold text-xs transition-all active:scale-95 shadow-md shadow-black/30 ${activeFilterCount > 0
                      ? "bg-secondary/20 border-secondary/50 text-secondary"
                      : "bg-zinc-900/90 border-zinc-800 text-zinc-200 hover:bg-zinc-800"
                      }`}
                  >
                    <FunnelIcon className="h-3.5 w-3.5 text-secondary" />
                    <span className="hidden xs:inline">Filters</span>
                    {activeFilterCount > 0 && (
                      <span className="px-1.5 py-0.2 rounded-full bg-secondary text-white text-[10px] font-black">
                        {activeFilterCount}
                      </span>
                    )}
                  </button>
                )}

                {/* Sort By Dropdown (Tracks View only, sm and desktop) */}
                {viewMode === "tracks" && (
                  <div className="hidden sm:inline-flex items-center">
                    <SelectBoxSimple
                      data={[...sortingData]}
                      label={"Sort By"}
                      onItemClick={onSorting}
                      selected={sortBy}
                      dark={true}
                    />
                  </div>
                )}

                {/* Grid vs List View Switcher (Tracks View only) */}
                {viewMode === "tracks" && (
                  <div className="flex items-center gap-0.5 p-1 rounded-xl bg-zinc-900 border border-zinc-800 shadow-inner">
                    <button
                      onClick={() => setCardLayout("grid")}
                      title="Grid View (Posters)"
                      className={`p-1.5 rounded-lg transition-all ${cardLayout === "grid"
                        ? "bg-secondary text-white shadow-sm"
                        : "text-zinc-400 hover:text-white"
                        }`}
                    >
                      <Squares2X2Icon className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => setCardLayout("list")}
                      title="List View (Streaming Rows)"
                      className={`p-1.5 rounded-lg transition-all ${cardLayout === "list"
                        ? "bg-secondary text-white shadow-sm"
                        : "text-zinc-400 hover:text-white"
                        }`}
                    >
                      <ListBulletIcon className="w-4 h-4" />
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* TIER 3: Edge-to-Edge Swipeable Quick-Filter Access Rail (Tracks View only) */}
            {viewMode === "tracks" && (
              <div className="flex items-center justify-between gap-3 pt-0.5">
                <div className="flex items-center gap-1.5 sm:gap-2 overflow-x-auto pb-1 scrollbar-none no-scrollbar w-full touch-pan-x">
                  {accessTabs.map((tab) => {
                    const isActive = selectedAccessType === tab.id;
                    const count = accessTypeCounts[tab.id] ?? 0;
                    return (
                      <button
                        key={tab.id}
                        onClick={() => onSelectAccessType(tab.id)}
                        className={`group flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-bold transition-all duration-200 whitespace-nowrap active:scale-95 border ${isActive
                          ? "bg-secondary text-white border-secondary shadow-md shadow-secondary/30 scale-[1.02]"
                          : "bg-zinc-900/80 hover:bg-zinc-850 text-zinc-300 border-zinc-800 hover:border-zinc-700"
                          }`}
                      >
                        <span className="text-xs">{tab.icon}</span>
                        <span>{tab.label}</span>
                        <span
                          className={`px-1.5 py-0.2 rounded-full text-[10px] font-black tracking-tight ${isActive
                            ? "bg-black/25 text-white"
                            : "bg-zinc-800 group-hover:bg-zinc-700 text-zinc-400"
                            }`}
                        >
                          {count}
                        </span>
                      </button>
                    );
                  })}
                </div>

                {/* Clear Filter Shortcut on Mobile/Tablet */}
                {(selectedAccessType !== "all" || categorySearchQuery) && (
                  <button
                    onClick={onClearAllFilters}
                    className="text-secondary hover:text-white font-bold text-xs whitespace-nowrap underline flex-shrink-0 hidden md:block"
                  >
                    Reset Filters
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ========================================================================= */}
        {/* MAIN CONTENT SECTION */}
        {/* ========================================================================= */}
        <section className="h-auto w-full px-3 sm:px-6 xl:px-14 py-4 sm:py-6 flex flex-col justify-center">
          <div className="mx-auto max-w-7xl w-full">
            <div className="lg:grid lg:grid-cols-4 lg:items-start lg:gap-8">
              {/* Desktop Left Sidebar Filter Section */}
              <div className="hidden space-y-4 lg:block">
                <FilterSection
                  onSelect={onSelect}
                  selectedFilter={selectedFilter}
                  dark={true}
                />
              </div>

              {/* Products / Content Main Column (Zero overflow, w-full) */}
              <div className="lg:col-span-3 w-full">
                {/* Active Filter Chips & Results Count Bar */}
                <div className="flex items-center justify-between gap-3 mb-4 px-1 text-xs text-zinc-400">
                  <div className="flex items-center gap-2 flex-wrap">
                    {viewMode === "playlists" ? (
                      <span>
                        Showing <strong className="text-white">{filteredPlaylists?.length || 0}</strong> of{" "}
                        {playlists?.length || 0} Curated Playlists
                      </span>
                    ) : (
                      <span>
                        Showing <strong className="text-white">{listData?.length || 0}</strong> of{" "}
                        {totalItemsCount || items?.length || 0} {isMusic ? "Songs" : "products"}
                      </span>
                    )}

                    {viewMode === "playlists" && playlistSearchQuery && (
                      <span className="px-2 py-0.5 rounded-md bg-secondary/15 text-secondary border border-secondary/30 font-semibold flex items-center gap-1">
                        <span>Query: &quot;{playlistSearchQuery}&quot;</span>
                        <button
                          onClick={() => setPlaylistSearchQuery("")}
                          className="hover:text-white font-bold"
                        >
                          ×
                        </button>
                      </span>
                    )}

                    {viewMode === "tracks" && categorySearchQuery && (
                      <span className="px-2 py-0.5 rounded-md bg-secondary/15 text-secondary border border-secondary/30 font-semibold flex items-center gap-1">
                        <span>Query: &quot;{categorySearchQuery}&quot;</span>
                        <button
                          onClick={() => setCategorySearchQuery("")}
                          className="hover:text-white font-bold"
                        >
                          ×
                        </button>
                      </span>
                    )}

                    {viewMode === "tracks" && selectedAccessType !== "all" && (
                      <span className="px-2 py-0.5 rounded-md bg-secondary/15 text-secondary border border-secondary/30 font-semibold flex items-center gap-1">
                        <span>
                          {activeTabConfig?.icon} {activeTabConfig?.label}
                        </span>
                        <button
                          onClick={onResetAccessFilter}
                          className="hover:text-white font-bold"
                        >
                          ×
                        </button>
                      </span>
                    )}
                  </div>

                  {((viewMode === "tracks" && (selectedAccessType !== "all" || categorySearchQuery || activeFilterCount > 0)) ||
                    (viewMode === "playlists" && playlistSearchQuery)) && (
                      <button
                        onClick={onClearAllFilters}
                        className="text-secondary hover:text-white font-bold underline text-xs"
                      >
                        Clear All
                      </button>
                    )}
                </div>

                {/* ========================================================================= */}
                {/* PLAYLISTS VIEW */}
                {/* ========================================================================= */}
                {viewMode === "playlists" ? (
                  <div className="space-y-6">
                    {playlistsLoading ? (
                      <div className="grid grid-cols-1 xs:grid-cols-2 min-h-[50vh] gap-3 sm:gap-4 md:grid-cols-3 xl:grid-cols-4 animate-pulse">
                        {[1, 2, 3, 4, 5, 6].map((i) => (
                          <PlaylistCardLoader key={i} dark={true} />
                        ))}
                      </div>
                    ) : filteredPlaylists.length ? (
                      <div className="grid grid-cols-1 xs:grid-cols-2 min-h-[50vh] gap-3 sm:gap-4 md:grid-cols-3 xl:grid-cols-4">
                        {filteredPlaylists.map((pl) => (
                          <PlaylistCard key={pl.id} {...pl} dark={true} />
                        ))}
                      </div>
                    ) : (
                      <div className="min-h-[45vh] flex flex-col items-center justify-center p-8 text-center bg-zinc-900/30 border border-zinc-800/60 rounded-2xl">
                        <div className="w-16 h-16 rounded-full bg-zinc-800/80 flex items-center justify-center text-3xl mb-4 border border-zinc-700/50">
                          💿
                        </div>
                        <h4 className="text-lg font-bold text-white mb-2">
                          No Playlists Found
                        </h4>
                        <p className="text-sm text-zinc-400 max-w-md mb-6">
                          {playlistSearchQuery
                            ? `We couldn't find any curated playlists matching "${playlistSearchQuery}".`
                            : "No curated playlists are available right now. Please check back later."}
                        </p>
                        {playlistSearchQuery && (
                          <button
                            onClick={() => setPlaylistSearchQuery("")}
                            className="px-6 py-2.5 rounded-xl bg-secondary text-white font-bold text-sm shadow-lg shadow-secondary/25 hover:bg-secondary/90 transition-all active:scale-95"
                          >
                            Show All Playlists
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  /* ========================================================================= */
                  /* TRACKS VIEW (PURE SONGS & SINGLES - NO PLAYLIST INTERRUPTION) */
                  /* ========================================================================= */
                  <>

                    {/* SKELETON LOADING STATE */}
                    {loading ? (
                      cardLayout === "list" ? (
                        <div className="flex flex-col gap-2.5 sm:gap-3 min-h-[60vh] animate-pulse">
                          {[1, 2, 3, 4, 5, 6].map((i) => (
                            <HorizontalCardLoader key={i} dark={true} layout="list" />
                          ))}
                        </div>
                      ) : (
                        <ul className="grid grid-cols-2 min-h-[60vh] gap-3 sm:gap-4 md:grid-cols-4 xl:grid-cols-5 animate-pulse">
                          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                            <li key={i}>
                              <HorizontalCardLoader dark={true} layout="grid" />
                            </li>
                          ))}
                        </ul>
                      )
                    ) : listData?.length ? (
                      /* LOADED PRODUCTS DISPLAY: GRID OR LIST */
                      cardLayout === "list" ? (
                        <div className="flex flex-col gap-2.5 sm:gap-3 min-h-[50vh]">
                          {listData.map((item, i) => (
                            <HorizontalListCard
                              key={item?.id || i}
                              {...item}
                              item={item}
                              dark={true}
                              layout="list"
                            />
                          ))}
                        </div>
                      ) : (
                        <ul className="grid grid-cols-2 min-h-[50vh] gap-3 sm:gap-4 md:grid-cols-4 xl:grid-cols-5">
                          {listData.map((item, i) => (
                            <li key={item?.id || i} className="flex justify-center">
                              <HorizontalListCard
                                {...item}
                                item={item}
                                dark={true}
                                layout="grid"
                              />
                            </li>
                          ))}
                        </ul>
                      )
                    ) : selectedAccessType !== "all" || categorySearchQuery ? (
                      /* EMPTY RESULTS FOR ACTIVE FILTERS */
                      <div className="min-h-[45vh] flex flex-col items-center justify-center p-8 text-center bg-zinc-900/30 border border-zinc-800/60 rounded-2xl shadow-xl">
                        <div className="w-16 h-16 rounded-full bg-zinc-800/80 flex items-center justify-center text-3xl mb-4 border border-zinc-700/50">
                          {activeTabConfig?.icon || "🔍"}
                        </div>
                        <h4 className="text-lg md:text-xl font-bold text-white mb-2">
                          No Matching Content Found
                        </h4>
                        <p className="text-sm text-zinc-400 max-w-md mb-6">
                          We couldn&apos;t find any items matching your active search and filters in{" "}
                          <span className="text-zinc-200 font-semibold">
                            {selectedCategory?.name || categoryTitle}
                          </span>
                          .
                        </p>
                        <button
                          onClick={onClearAllFilters}
                          className="px-6 py-2.5 rounded-xl bg-secondary text-white font-bold text-sm shadow-lg shadow-secondary/25 hover:bg-secondary/90 transition-all active:scale-95"
                        >
                          Reset All Filters ({items?.length || 0} Total Items)
                        </button>
                      </div>
                    ) : (
                      /* GENERAL CATEGORY EMPTY STATE */
                      <EmptyList
                        description={`There are no items in ${selectedCategory?.name || categoryTitle}`}
                        image={emptyItem}
                        btn={false}
                      />
                    )}

                    {/* PAGINATION */}
                    {!loading && listData?.length ? (
                      <Pagination
                        {...{
                          totalItemsCount,
                          currentPage,
                          lastPage,
                          perPageCount,
                          onBtnClick: getItems,
                          dark: true,
                        }}
                      />
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <Footer onCategoryPress={onCategoryPress} /> */}
      <FooterNew />

      {/* Modern Filter Slide-Over Drawer with Sticky Action Bar */}
      <FilterModal
        open={open}
        onOpen={openFilter}
        onClose={closeFilter}
        onSelect={onSelect}
        selectedFilter={selectedFilter}
        dark={true}
        onResetAll={onClearAllFilters}
        totalResultsCount={listData?.length || 0}
      />
    </>
  );
}
